var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-container"},[_c('div',{staticClass:"image-viewer",style:('background-image: url(' + _vm.params.data.picture + ')')})])}
var staticRenderFns = []

export { render, staticRenderFns }